module.exports = __webpack_public_path__ + "static/media/FAQs icon (active).28e4d88a.svg";